var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Stock Category",
                  value: _vm.stockCategory.name
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Service", type: "number" },
                model: {
                  value: _vm.service,
                  callback: function($$v) {
                    _vm.service = $$v
                  },
                  expression: "service"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Farrowing", type: "number" },
                model: {
                  value: _vm.farrowing,
                  callback: function($$v) {
                    _vm.farrowing = $$v
                  },
                  expression: "farrowing"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: { label: "Weaning", type: "number" },
                model: {
                  value: _vm.weaning,
                  callback: function($$v) {
                    _vm.weaning = $$v
                  },
                  expression: "weaning"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-btn",
        {
          attrs: {
            color: "primary",
            dark: "",
            dense: "",
            small: "",
            loading: _vm.sowPigCyclePreferencePosting
          },
          on: { click: _vm.saveSowPigData }
        },
        [_c("span", [_vm._v("Save")])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }